/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Basic_Payment_TitleInputs */

const en_admin_settings_groups_basic_payment_title = /** @type {(inputs: Admin_Settings_Groups_Basic_Payment_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic`)
};

/**
* | output |
* | --- |
* | "Basic" |
*
* @param {Admin_Settings_Groups_Basic_Payment_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_basic_payment_title = /** @type {((inputs?: Admin_Settings_Groups_Basic_Payment_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Basic_Payment_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_basic_payment_title(inputs)
});
export { admin_settings_groups_basic_payment_title as "admin.settings.groups.basic_payment.title" }